import React, { useMemo } from "react";
import { teaserHtml } from "./teaserAnim";

// Short looping animation that invites a visitor to try the free lesson.
// Tap anywhere on it to start. Uses no video file, so it loads instantly.
export default function TryFreeTeaser({ onStart, ratio = "1 / 1" }) {
  const { html, css } = useMemo(() => teaserHtml({ img: "/academy/goat-portrait.jpg" }), []);
  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="Try the free MbuziPlus lesson. It is free and takes 20 minutes."
      onClick={onStart}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onStart && onStart(); } }}
      style={{ cursor: "pointer", width: "100%", maxWidth: 560, margin: "0 auto" }}
    >
      <style>{css}</style>
      <div className="tf-box" style={{ aspectRatio: ratio }} dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
